:host,
:host *,
:host *::after,
:host *::before {
  box-sizing: border-box;
}

#overlay {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow-y: auto;
  width: 100%;
  height: 100%;
  background: rgba(0, 75, 135, 0.8);
  padding: 32px 48px;
  opacity: 0;
}

#overlay.animated {
  animation: fadeIn var(--duration-medium-2) var(--curve-expressive-ease-out) 0.2s forwards;
}

#overlay.closed {
  opacity: 1;
  animation: fadeOut var(--duration-medium-1) var(--curve-expressive-ease-in) 0.25s forwards;
}

#overlay.animated.closed #modal-container {
  animation: popOut var(--duration-medium-3) var(--curve-expressive-ease-in) forwards;
}

#overlay.animated.closed #floating-cta-container {
  animation: slideOut var(--duration-xfast) var(--curve-simple-ease-in) forwards;
}

#modal-container {
  max-width: 1200px;
  flex: 1;
  width: 100%;
  background: white;
  border-radius: 24px;
  opacity: 0;
  transform: scale(0);
  display: flex;
  flex-direction: column;
}

#overlay.animated #modal-container {
  animation: popIn var(--duration-xxslow) var(--curve-expressive-ease-out) 0.4s forwards;
}

#modal-header {
  width: 100%;
  padding: 48px 80px;
  display: flex;
  position: relative;
  justify-content: center;
}

#modal-header-content {
  display: flex;
  gap: 24px;
}

#modal-header-spacer {
  flex: 1;
}

#modal-header-spacer.animated {
  flex: 0;
  transition: flex-grow var(--duration-xxslow) var(--curve-expressive-ease-in-out);
}

#logo {
  opacity: 0;
  height: 88px;
}

#logo svg {
  height: 100%;
}

#logo-2 {
  height: 88px;
}

#logo-2 svg {
  height: 100%;
}

#logo-2.slideout {
  opacity: 1;
  animation: slideOut var(--duration-medium-1) var(--curve-expressive-ease-in) 0.1s forwards;
}

#overlay.animated #logo {
  animation: slideInFromBottom var(--duration-slow) var(--curve-expressive-ease-out) 0.825s forwards;
}

#overlay.animated.refreshed #logo {
  animation: slideInFromBottom var(--duration-slow) var(--curve-expressive-ease-out) 0.1s forwards;
}

#modal-header-title-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-self: center;
}

#title {
  opacity: 0;
  margin: 0;
}

#title-2 {
  font: var(--title-2);
  color: var(--grid-content-primary);
  margin: 0;
  padding: 0;
  max-width: 16.8em;
  opacity: 0;
  animation: slideInFromRight var(--duration-medium-3) var(--curve-expressive-ease-out) 0.25s forwards;
}

#title-2.slideout {
  opacity: 1;
  animation: slideOut var(--duration-medium-1) var(--curve-expressive-ease-in) 0.1s forwards;
}

#overlay.animated #title {
  animation: slideInFromBottom var(--duration-slow) var(--curve-expressive-ease-out) 0.85s forwards;
}

#overlay.animated #title.slideout,
#overlay.animated.refreshed #title.slideout {
  opacity: 1;
  animation: fadeOut var(--duration-medium-2) var(--curve-expressive-ease-in) 0.025s forwards;
}

#overlay.animated #subtitle.slideout,
#overlay.animated.refreshed #subtitle.slideout {
  opacity: 1;
  animation: fadeOut var(--duration-medium-2) var(--curve-expressive-ease-in) 0s forwards;
}

#overlay.animated.refreshed #title {
  animation: slideInFromBottom var(--duration-slow) var(--curve-expressive-ease-out) 0.25s forwards;
}

#subtitle,
#subtitle-mobile {
  opacity: 0;
}

#subtitle-mobile {
  display: none;
}

#overlay.animated #subtitle,
#overlay.animated #subtitle-mobile {
  animation: slideInFromBottom var(--duration-slow) var(--curve-expressive-ease-out) 0.875s forwards;
}

#overlay.animated.refreshed #subtitle,
#overlay.animated.refreshed #subtitle-mobile {
  animation: slideInFromBottom var(--duration-slow) var(--curve-expressive-ease-out) 0.3s forwards;
}

#title {
  font: var(--title-1);
  color: var(--grid-content-primary);
}

#subtitle,
#subtitle-mobile {
  font: var(--title-3);
  color: var(--grid-content-primary);
}

#close-button-container {
  position: absolute;
  top: 8px;
  right: 32px;
}

#modal-body {
  padding: 0px 80px;
  padding-bottom: 48px;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#floating-cta-container {
  display: none;
}

#refresh-button-container {
  height: 0px;
  flex-shrink: 0;
  overflow: hidden;
  animation: expand var(--duration-medium-3) var(--curve-expressive-ease-in-out) 0.25s forwards;
}

#refresh-button-container.refreshing {
  height: 88px;
  animation: shrink var(--duration-medium-3) var(--curve-expressive-ease-in) forwards;
}

#refresh-button {
  padding-top: 40px;
  display: block;
}

@media screen and (max-width: 1200px) {
  #modal-header {
    padding-left: 48px;
  }

  #modal-body {
    padding-left: 48px;
    padding-right: 48px;
  }
}

@media screen and (min-width: 990px) and (min-height: 800px) {
  #overlay {
    justify-content: center;
  }

  #modal-container {
    max-height: 768px;
  }
}

@media screen and (max-width: 989px) {
  #overlay {
    padding: 0;
  }

  #modal-container {
    border-radius: 0;
  }

  #modal-header {
    padding-right: 48px;
    padding-top: 64px;
    padding-bottom: 32px;
  }

  #modal-body {
    padding-bottom: 136px;
    overflow-x: hidden;
  }

  #logo,
  #logo-2 {
    height: 72px;
  }

  #title {
    font: var(--title-2);
  }

  #subtitle,
  #subtitle-mobile {
    font: var(--headline-2);
  }

  #floating-cta-appuntamento-container {
    display: block;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    padding-top: 24px;
    color: var(--grid-content-primary);
    border-top: 1px solid var(--grid-border-color-02);
  }

  #floating-cta-appuntamento-container .link {
    color: var(--grid-content-primary);
    font-weight: 700;
  }

  #floating-cta-container {
    display: flex;
    flex-direction: column;
    gap: 24px;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 24px 48px;
    background: var(--grid-background-color-01);
    box-shadow: 0px -4px 16px rgba(0, 0, 0, 0.1);
    opacity: 0;
  }

  #overlay.animated #floating-cta-container {
    animation: slideInFromBottom var(--duration-xslow) var(--curve-expressive-ease-out) 1.3s forwards;
  }

  #floating-buttons-container {
    display: flex;
    flex-direction: row-reverse;
    flex-wrap: wrap;
    gap: 32px;
  }
}

@media screen and (max-width: 767px) {
  #modal-header {
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 52px;
    padding-bottom: 24px;
    flex-direction: column;
    gap: 12px;
  }

  #modal-header-spacer {
    display: none;
  }

  #modal-header-content {
    gap: 16px;
  }

  #close-button-container {
    top: 0;
    right: 16px;
  }

  #modal-body {
    padding-left: 16px;
    padding-right: 16px;
    padding-bottom: 104px;
    /* padding-bottom: 24px; */
  }

  #logo,
  #logo-2 {
    height: 56px;
  }

  #title {
    font: var(--title-4);
  }

  #subtitle,
  #subtitle-mobile {
    font: var(--headline-3);
  }

  #subtitle-mobile {
    display: block;
  }

  #subtitle {
    display: none;
  }

  #title-2 {
    font: var(--title-4);
  }

  #floating-cta-appuntamento-container {
    font-size: 14px;
    line-height: 18px;
    padding-top: 16px;
  }

  #floating-cta-container {
    gap: 16px;
    padding: 16px 16px;
  }
}

@keyframes slideInFromLeft {
  0% {
    opacity: 0;
    transform: translateX(-48px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInFromRight {
  0% {
    opacity: 0;
    transform: translateX(48px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInFromBottom {
  0% {
    opacity: 0;
    transform: translateY(48px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInFromBottomXL {
  0% {
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    opacity: 0;
    transform: translateY(50%);
  }
  99% {
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    border-radius: 0;
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  99% {
    opacity: 0;
  }
  100% {
    opacity: 0;
    visibility: hidden;
    display: none;
  }
}

@keyframes slideOut {
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(48px);
  }
}

@keyframes popIn {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes popOut {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0);
  }
}

@keyframes expand {
  0% {
    height: 0px;
  }
  100% {
    height: 88px;
  }
}

@keyframes shrink {
  0% {
    height: 88px;
  }
  100% {
    height: 0px;
  }
}
